import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import styles from './Tag.module.scss';

export type TagVariant = 'yellow' | 'red' | 'blue' | 'purple';

interface TagProps {
  text: string;
  variant: TagVariant;
  icon?: IconProp;
}

const variantStyleMap: Record<TagVariant, string> = {
  yellow: styles.yellowTag,
  red: styles.redTag,
  blue: styles.blueTag,
  purple: styles.purpleTag,
};

function Tag({text, variant, icon}: TagProps) {
  return (
    <span className={variantStyleMap[variant]}>
      {icon && <FontAwesomeIcon icon={icon} />} {text}
    </span>
  );
}

export default Tag;
